<template>
  <div class="flex flex-col w-full">
    <div
      class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 rounded-xl overflow-hidden"
    >
      <!-- <DashboardBlock
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10"
        img="/icon/buy-tax.png"
        :title="`${tokenSymbol} Buy Tax`"
        :amount="`${currentTaxFormatted}%`"
      /> -->
      <DashboardBlock
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10"
        img="/icon/borrow-apr.png"
        title="Borrow APR"
        :amount="`${borrowAprFormatted}%`"
      />
      <DashboardBlock
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10"
        img="/icon/lending.png"
        title="Total Pool Available"
        :amount="`${lendingPoolAvailableFormatted} ${nativeCurrencySymbol}`"
      />
      <DashboardBlock
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10"
        img="/icon/lending.png"
        title="Total Pool Utilized"
        :amount="`${lendingPoolUtilizedFormatted} ${nativeCurrencySymbol}`"
      />
      <DashboardBlock
        class=""
        img="/icon/pending-fees.png"
        title="Total Fees"
        :amount="`${ethRewardsTotalOverallFormatted} ${nativeCurrencySymbol}`"
      />
      <DashboardBlock
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10"
        img="/icon/lending.png"
        title="Main Pool Available"
        :amount="`${lendingPoolMainAvailableFormatted} ${nativeCurrencySymbol}`"
      />
      <!-- <DashboardBlock
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10"
        img="/icon/lending.png"
        title="Main Pool Utilized"
        :amount="`${0} ${nativeCurrencySymbol}`"
      /> -->
      <DashboardBlock
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10"
        img="/icon/lending.png"
        title="HLP Pool Available"
        :amount="`${lendingPoolExtAvailableFormatted} ${nativeCurrencySymbol}`"
      />
      <!-- <DashboardBlock
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10"
        img="/icon/lending.png"
        title="HLP Pool Utilized"
        :amount="`${0} ${nativeCurrencySymbol}`"
      /> -->
      <div
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10 bg-block-2 p-5"
      ></div>
      <div
        class="border-r border-b xl:border-b-0 border-gray-4 border-opacity-10 bg-block-2 p-5"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardBlock from "./DashboardBlock.vue";
export default {
  name: "DashboardStats",
  components: {
    DashboardBlock,
  },

  computed: {
    ...mapGetters([
      "borrowAprFormatted",
      "currentTaxFormatted",
      "ethRewardsTotalOverallFormatted",
      "lendingPoolAvailableFormatted",
      "lendingPoolUtilizedFormatted",
      "lendingPoolMainAvailableFormatted",
      "lendingPoolExtAvailableFormatted",
      "nativeCurrencySymbol",
      "tokenSymbol",
    ]),
  },
};
</script>
